module.exports = __webpack_public_path__ + "img/loading.25c8dee7.png";